import script from "./IssueLabels.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueLabels.vue?vue&type=script&setup=true&lang=js"

import "./IssueLabels.vue?vue&type=style&index=0&id=c6c89386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6c89386"]])

export default __exports__